(() => {
  const normalizeProductSpecs = () => {
    document.querySelectorAll('.rvp__spec-copy .row-m4GA').forEach((row) => {
      const children = Array.from(row.children);
      if (children.length !== 1) return;

      const packedValue = children[0];
      if (!packedValue.classList.contains('rowValue-J0hf')) return;

      const strong = packedValue.querySelector(':scope > strong');
      if (!strong) return;

      const label = strong.textContent.replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
      const fullText = packedValue.textContent.replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
      if (!label || !fullText.toLowerCase().startsWith(label.toLowerCase())) return;

      const value = fullText.slice(label.length).trim();
      if (!value) return;

      const labelWrap = document.createElement('span');
      const labelStrong = document.createElement('strong');
      labelStrong.textContent = label;
      labelWrap.appendChild(labelStrong);

      const valueWrap = document.createElement('span');
      valueWrap.className = 'rowValue-J0hf';
      valueWrap.textContent = value;

      row.replaceChildren(labelWrap, valueWrap);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', normalizeProductSpecs, { once: true });
  } else {
    normalizeProductSpecs();
  }
})();
